<template>
  <div v-if="user">
    <section class="hero is-large">
      <div class="hero-head">
        <header class="nav">
          <div class="container is-fluid">

            <div class="nav-left">
              <a class="nav-item" href="/">
                <img src="/images/wp.png"/>
              </a>
            </div>

            <span class="nav-toggle" @click="toggleHidden()">
              <span></span>
              <span></span>
              <span></span>
            </span>

            <div class="nav-right nav-menu">
              <template v-if="!hideNav">
                <div class="app-nav-wrapper">
                  <router-link active-class="is-active" class="nav-item" to="/a/documents">{{ $t('navigation.proposals') }}</router-link>
                  <router-link active-class="is-active" class="nav-item" to="/a/templates">{{ $t('navigation.templates') }}</router-link>
                  <router-link active-class="is-active" class="nav-item" to="/a/content-blocks">{{ $t('navigation.modules') }}</router-link>
                  <router-link active-class="is-active" class="nav-item" to="/a/activity">{{ $t('navigation.activity') }}</router-link>
                  <router-link active-class="is-active" class="nav-item" to="/a/contacts">{{ $t('navigation.contacts') }}</router-link>
                </div>

                <span class="nav-item new-button">
                  <a @click="Events.$emit('modalOpen', 'newDocumentModal')" class="button is-primary is-outlined">
                    <span>{{ $t('navigation.new_proposal') }}</span>
                  </a>
                </span>

                <span class="nav-item new-button">
                  <a @click="Events.$emit('modalOpen', 'newContactModal')" class="button is-primary is-outlined">
                    <span>{{ $t('navigation.new_contact') }}</span>
                  </a>
                </span>
              </template>

              <a class="nav-item account">
                <figure class="image is-24x24 is-" style="margin-right: 8px;">
                  <span class="badge"></span>
                  <i class="activity-indicator" v-if="hasUnreadNotifications || hasUnreadAnnouncements"></i>
                  <img :src="user.photo_url"/>
                </figure>
                <i class="icon icon-chevron-down"></i>
                <div class="dropdown-content">
                  <ul>
                    <li>
                      <router-link active-class="is-active" to="/a/settings">{{ $t('navigation.account_settings') }}</router-link>
                    </li>

                    <li>
                      <a @click="showNotifications" class="nav-item has-activity-indicator">
                        <i class="activity-indicator" v-if="hasUnreadNotifications || hasUnreadAnnouncements"></i>Notifications
                      </a>
                    </li>

                    <li>
                      <a @click.prevent="Events.$emit('modalOpen', 'supportFormModal', { supportForm: supportForm })" style="cursor: pointer;">
                        {{ $t('navigation.support') }}
                      </a>
                    </li>

                    <li v-if="Spark.impersonating">
                        <a href="/spark/kiosk/users/stop-impersonating">
                            <i class="fa fa-fw fa-btn fa-user-secret"></i> {{ $t('navigation.stop_impersonating') }}
                        </a>
                    </li>

                    <li v-if="user.is_developer">
                      <a href="/spark/kiosk">
                        {{ $t('navigation.kiosk') }}
                      </a>
                    </li>

                    <!-- <li>
                      <a @click="modals.showIntegrationsModal = true">{{ $t('navigation.app_integrations') }}</a>
                    </li> -->
                    <li>
                      <a @click="Events.$emit('modalOpen', 'shareModal')">{{ $t('navigation.spread_the_love') }}</a>
                    </li>
                    <li class="teams">
                      <ul>
                        <span>{{ $t('navigation.teams') }}</span>
                        <li v-for="team in teams" :key="team.id"><a :href="'/switch-team/' + team.id" :class="{ 'active-team' : currentTeam.id === team.id }">{{ team.name }}</a></li>
                      </ul>
                    </li>
                    <!-- <li>
                      <a @click="modals.showWhatsNewModal = true">{{ $t('navigation.whats_new') }}</a>
                    </li> -->
                    <li>
                      <a href="/logout">{{ $t('navigation.log_out') }}</a>
                    </li>
                  </ul>
                </div>
              </a>
            </div>
          </div>
        </header>
      </div>
    </section>
  </div>
</template>

<script>
import API from 'mixins/api';

export default {
  mixins: [API],
  props: [
    'hideNav',
    'user',
    'currentTeam',
    'teams',
    'notifications',
    'loadingNotifications',
    'hasUnreadNotifications',
    'hasUnreadAnnouncements',
    'supportForm',
  ],
  data () {
    return {
      Events: window.Events,
      Spark: window.Spark,
    }
  },
  methods: {
    showNotifications() {
      this.Events.$emit('modalOpen', 'notificationsModal', {
        notifications: this.notifications.notifications,
        announcements: this.notifications.announcements,
        loadingNotifications: this.loadingNotifications,
        hasUnreadNotifications: this.hasUnreadNotifications,
        hasUnreadAnnouncements: this.hasUnreadAnnouncements,
      });
    },
  },
  watch: {
    modals: {
      handler() {
        this.Events.$emit('blurApp', false);
        _.each(this.modals, (modal) => {
          if (modal) {
            this.Events.$emit('blurApp', true);
          }
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";

.has-activity-indicator {
  position: relative;
}

.activity-indicator {
  display: block;
  position: absolute;
  width: 9px;
  height: 9px;
  background-color: $red;
  border-radius: 50%;
  margin-left: 20px;
  border: 1px solid $white;
}

.teams a {
  display: block;
  width: 100%;
}

.nav-right {
  .settings-nav-wrapper,.app-nav-wrapper {
    display: inherit;
  }

  .nav-item {
    font-size: 14px;
    color: $black;
    &:hover {
      background: darken($eggshell, 2%);
    }
    &.is-active {
      font-weight: 600;
      color: $purple;
      background: darken($eggshell, 2%);
    }
    .button {
      border-radius: 2.5em;
    }
    .button.is-outlined {
      text-transform: uppercase;
      padding: 15px 20px 13px;
      span {
        font-size: 12px;
      }
    }
    &.new-button {
      padding: 0 0.5rem;
      &:hover {
        background: none;
      }
    }
    &.account {
      figure {
        border-radius: 50%;
        background: $purple url(https://app.workpapers.io/images/placeholder.png) center center no-repeat;
        background-size: 100%;
        img {
          border-radius: 50%;
        }
      }
      i {
        color: $mutedblue;
        font-size: 19px;
      }
      .dropdown-content {
        top: 45px;
        right: 0px;
			  display: none;
			  position: absolute;
			  background-color: $white;
        box-shadow: 0 2px 13px 1px rgba(211,215,221,0.60);
				padding: 0;
				border-radius: 5px;
				margin-top: 0;
        text-align: left;
        overflow: hidden;
				ul {
          margin: 0;
          li {
            a {
              color: $black;
              padding: 7px 20px;
              width: 100%;
              min-width: 180px;
              display: inline-block;
              &:hover {
                background: darken($eggshell, 2%);
              }
              .activity-indicator {
                top: 13px;
                right: 14px;
              }
            }
            &:last-child {
              margin-top: 0;
              margin-bottom: 0;
              border-top: 1px solid lighten($mutedblue, 17%);
            }
            ul {
              margin-top: 0;
              span {
                background: $purple;
                color: $white;
                padding: 7px 30px;
                width: 100%;
                text-transform: uppercase;
                letter-spacing: 1px;
                font-size: 10px;
                font-weight: 600;
                display: block;
              }
              li {
                a.active-team {
                  // background: darken($eggshell, 2%);
                  font-weight: 600;
                }
                &:last-child {
                  margin-top: 0;
                  border-top: none;
                }
              }
            }
          }
        }
			}
			&:hover {
        background: darken($eggshell, 2%);
        i {
          color: $grey;
        }
				.dropdown-content {
				  display: block;
				}
			}
    }
  }

}

.nav-left {
  .nav-item {
    img {
      width: 45px;
      height: 23px;
    }
  }
}

.hero {
  width: 100%;
  z-index: 1;
  .hero-head {
    header.nav {
      position: fixed;
      width: 100%;
      background: $white;
      border-bottom: 1px solid lighten($mutedblue, 12%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// app-nav.vue?50fccc6a